import React from "react";
// import "./logindetails.scoped.css";

export default function SendLoginDetails({ show, setShow }) {
  const shareDetails = (client) => {
    let url = `https://api.whatsapp.com/send?text=
        New Password
        %0ALink: ${show?.userType?.toLowerCase() === "client"
        ? `https://${process.env.REACT_APP_APP_NAME}.net`
        : `https://operator.${process.env.REACT_APP_APP_NAME}.net`}
        %0AId: ${show?.username}
        %0APassword: ${show?.password}`;
    window.open(url, "_blank");
  };
  return (
    <div
      id="detailaModal"
      className="sitemoadal modal fade show"
      aria-modal="true"
      role="dialog"
      style={{ display: "block" }}
    >
      <div

        className="modal-dialog modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5

              id="exampleModalLabel"
              className="modal-title"
            >
              Reset Password
            </h5>
            <button

              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setShow(null);
              }}
              className="btn-close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="bet-slip-box">
              <div className="bet-slip">
                <textarea

                  readOnly=""
                  className="ant-input usertextarea"
                  defaultValue={` New Password\n  LINK : ${show?.userType?.toLowerCase() == "client"
                    ? `${process.env.REACT_APP_APP_NAME}.net`
                    : `operator.${process.env.REACT_APP_APP_NAME}.net`
                    }\n  ID : ${show?.username}\n  PW : ${show?.password
                    }\n  \n  `}
                />
              </div>

              <div

                className="place-bet-btn mt-4 text-align" >
                <button
                  onClick={() => {
                    navigator.clipboard.writeText(
                      `New Password\n  LINK : ${window.location.hostname
                      }\n  ID : ${show?.username}\n  PW : ${show?.password
                      }\n  \n  `
                    );
                    shareDetails(show);
                    setShow(null);
                  }}

                  className="btn btn-primary btn-block" >
                  <span>Share on WhatsApp</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
